module.exports = __webpack_public_path__ + "static/media/orthotkl.db0aa91d.jpeg";